import { PASSWORD_VALIDATION_OBJECT } from '@acorns/web-components'
import { BooleanSchema, StringSchema, boolean, object, string } from 'yup'

import { transformErrors } from 'utils/errors'
import { noSpecialCharacters } from 'utils/validationSchema'

import { isClickId } from './queryParams'

noSpecialCharacters()

export const requiredString = () => string().required('This field is required')

export const validationErrorMap = new Map<string, string>([
  ['email', 'Please enter a valid email'],
  ['password', 'Please enter a valid password'],
  [
    'usResident',
    'To proceed, please confirm that you are a U.S. resident, at least 18 years old, and agree to the Program Agreement, Privacy Policy, and Auto Debit Authorization.',
  ],
  ['partnerDisclosure', 'You must read the partner referral disclosure to join Acorns'],
])

const emailValidationMessage = 'Please enter a valid email'
export const emailTypoMessage = (email: string) => `Did you mean ${email}?`
const emailMaxValidationMessage = 'Email must be ${max} characters or less.'

const checkboxValidationMessage = 'This field is required'

type ValidationSchema = {
  email: StringSchema
  password: StringSchema
  usResident: BooleanSchema
  partnerDisclosure?: BooleanSchema
}

// Handles Formik's validate event.
export const validate = (values) => {
  let errors = {}
  try {
    validationSchema().validateSync(values, { abortEarly: false })
  } catch (validationErrors) {
    // Convert validation errors to Formik errors collection
    errors = transformErrors(validationErrors.inner)
  }

  return errors
}

// Validation schema to be used by Formik.
export const validationSchema = () => {
  const schema: ValidationSchema = {
    email: requiredString()
      .email(emailValidationMessage)
      .max(65, emailMaxValidationMessage)
      .excludeSpecialCharacters(),
    password: PASSWORD_VALIDATION_OBJECT,
    usResident: boolean().oneOf([true], checkboxValidationMessage),
  }

  // If the customer is referred by an affiliate, the schema is extended to include the "partnerDisclosure" field
  if (isClickId()) {
    schema.partnerDisclosure = boolean().oneOf([true], checkboxValidationMessage)
  }

  return object().shape(schema)
}
